import { useNavigate } from "react-router-dom";
import React from "react";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  SYMBOL_CURRENCY,
  TEXT_ARE_YOU_SURE,
  TEXT_CANCEL,
  TEXT_DELETE,
  TEXT_DELETE_PROGRAM,
  TEXT_EDIT,
} from "../../../utils/useConstants";
import { ICON_PROGRAM_GET_BY_TYPE_FLEX } from "../../../utils/useIcons";
import {
  STYLE_BODY_3_REGULAR,
  STYLE_DELETE_BUSKET,
  STYLE_DELETE_BUSKET_DISABLED,
  STYLE_DETAILS_ADDONS_BUSKET,
  STYLE_EDIT_BUSKET,
  STYLE_HEADING_3_BOLD_24_18,
  STYLE_HEADING_3_BOLD_24_18_TH,
  STYLE_PARENT_DELETE_PROGRAM,
  STYLE_PARENT_PROGRAM_SIZE,
  STYLE_SUB_TEXT_DETAIL,
  STYLE_TITLE_BOLD,
  STYLE_TITLE_SEMIBOLD,
} from "../../../utils/useStyle";
import { ContextCart } from "../../../context/Context.Cart";
import BasketDeleteOrder from "../function/Basket.DeleteOrder";
import TemplateModal from "../../../components/template/Template.Modal";
import { STATE_CONSTANTS_PROGRAM } from "../../../utils/useConstantState";
import { splitOrNotFor, splitOrTh } from "../../../utils/useFunction";

const BusketRenderProgram = ({ data, raw, index }) => {
  const navigate = useNavigate();
  const { language } = React.useContext(ContextLanguage);
  const [open, setOpen] = React.useState(false);
  const { setCart, Storage } = React.useContext(ContextCart);

  const canDelete = true;
  // raw?.filter((item) => {
  //   return item.type === "PACKAGE";
  // }).length > 1;

  let master_id = data?.master_id;
  // const master = data?.value?.find((item) => item?.master === true);
  const master = data;
  // const addons = data?.value?.filter((item) => !item?.master);
  const addons = raw?.filter((item) => {
    return (
      item?.master_id === master_id &&
      (item?.type === "ADDON" || item?.type === "EXTRA")
    );
  });

  // const price = Number(
  //   Number(
  //     FunctionSum(
  //       addons?.map((item) => {
  //         if (item?.type === "ADDON") {
  //           return item[String(master.size).toLowerCase()];
  //         } else {
  //           return item?.price;
  //         }
  //       })
  //     )
  //   ) + Number(master?.price)

  // );

  // console.log("master", master);

  return (
    <div
      className={`flex items-start space-x-4 border-b border-[#D0D3E5] py-4`}
    >
      <div className="">
        <ICON_PROGRAM_GET_BY_TYPE_FLEX type={master?.master_type} />
      </div>
      <div className={`w-[95%]`}>
        <div
          className={`${STYLE_TITLE_BOLD(language)} ${
            language === "TH"
              ? " text-base-th md:text-lg-th "
              : " text-base md:text-lg "
          } flex justify-between -mt-[4px]`}
        >
          <div>
            {language === "TH"
              ? master?.master_name_th
              : master?.master_name_en}
            <span className=" mx-1 font-normal">|</span>
            <React.Fragment>
              {language === "TH"
                ? splitOrTh(master?.name_th)?.map((row, i) => {
                    if (i === 0) {
                      return (
                        <React.Fragment key={`asdx-${i}`}>{row}</React.Fragment>
                      );
                    } else {
                      return <div key={`asdx-${i}`}>หรือ {row}</div>;
                    }
                  })
                : splitOrNotFor(master?.name_en)?.map((row, i) => {
                    if (i === 0) {
                      return (
                        <React.Fragment key={`asdx-${i}`}>{row}</React.Fragment>
                      );
                    } else {
                      return <div key={`asdx-${i}`}>or {row}</div>;
                    }
                  })}
            </React.Fragment>
          </div>

          <div className={STYLE_TITLE_SEMIBOLD(language)}>
            <span className="font-NotoSansThai">{SYMBOL_CURRENCY}</span>
            {master?.price}
          </div>
        </div>
        <div className={`${language === "TH" ? " text-xs-th " : " text-xs "}`}>
          ({language === "TH" ? data?.name_th : data?.name_en})
        </div>
        <div className={STYLE_PARENT_PROGRAM_SIZE}>
          <div className={STYLE_TITLE_BOLD(language)}>
            <div className={STYLE_SUB_TEXT_DETAIL(language)}>
              {master?.master_type === !STATE_CONSTANTS_PROGRAM.MY_SHOE && (
                <React.Fragment>
                  {language === "TH" ? master?.name_th : master?.name_en}
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
        {addons?.map((addon, index) => {
          return (
            <div
              key={`key-of-addon-${index}`}
              className={`flex justify-between items-center mt-1 ${STYLE_DETAILS_ADDONS_BUSKET(
                language
              )}`}
            >
              <div className="">
                {language === "TH" ? addon?.name_th : addon?.name_en}
              </div>
              <div>
                <span className="font-NotoSansThai">{SYMBOL_CURRENCY}</span>
                {addon?.type === "ADDON" ? (
                  <React.Fragment>
                    {addon[String(master?.size).toLowerCase()] || 0}
                  </React.Fragment>
                ) : (
                  <React.Fragment>{addon?.price || 0}</React.Fragment>
                )}
              </div>
            </div>
          );
        })}
        <div className={`flex justify-between my-1.5`}>
          <div
            onClick={() => {
              if (canDelete) {
                setOpen(true);
              } else {
                return;
              }
            }}
            className={
              canDelete
                ? STYLE_DELETE_BUSKET(language)
                : STYLE_DELETE_BUSKET_DISABLED(language)
            }
          >
            {TEXT_DELETE[language]}
          </div>
          <div
            onClick={() => {
              // sessionStorage.setItem("program", master?.master_type);
              // sessionStorage.setItem("program_id", master_id);
              // navigate(`/Program`);
              if (master?.master_type === "My Shoes") {
                navigate(`/MyShoes`);
              } else if (master?.master_type === "My Iron") {
                navigate(`/MyIron`);
              } else {
                navigate(`/MyWash`);
              }
              // setValue({
              //   ...value,
              //   isEditOpen: !value?.isEditOpen,
              // });
            }}
            className={`${STYLE_EDIT_BUSKET(language)} mr-0 `}
          >
            {TEXT_EDIT[language]}
          </div>
        </div>
        <TemplateModal
          acceptText={
            <div
              className={`${language === "TH" ? "text-base-th" : "text-base"}`}
            >
              {TEXT_DELETE[language]}
            </div>
          }
          // cancelText={TEXT_CANCEL[language]}
          cancelText={
            <div
              className={`${language === "TH" ? "text-base-th" : "text-base"}`}
            >
              {TEXT_CANCEL[language]}
            </div>
          }
          save={() => {
            if (canDelete) {
              BasketDeleteOrder(
                setCart,
                master?.master_type,
                Storage,
                master_id
              );
            } else {
              return;
            }
          }}
          showCloseButton={true}
          showSaveButton={true}
          open={open}
          setOpen={setOpen}
          panel={
            <div
              className={`${STYLE_PARENT_DELETE_PROGRAM} ${
                language === "TH" ? "font-NotoSansThai" : "font-Poppins"
              }  `}
            >
              <div
                className={`${
                  language === "TH"
                    ? STYLE_HEADING_3_BOLD_24_18_TH
                    : STYLE_HEADING_3_BOLD_24_18
                } text-center h-h_30 `}
              >
                {TEXT_DELETE_PROGRAM[language]}
              </div>
              <div
                className={` py-3 md:pt-6 h-h_50 text-laundry-gray-80 text-center ${STYLE_BODY_3_REGULAR(
                  language
                )}`}
              >
                {TEXT_ARE_YOU_SURE[language]}
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default BusketRenderProgram;
